import React from 'react'
import PropTypes from 'prop-types'
import StyledContainer from './styled'
import Button from '../button/index'

const ButtonGroup = (props) => {
  const {
    type,
    activeType,
    activeKey,
    size,
    options,
    style,
    className,
    borderRadius,
    backgroundColor,
    borderColor, // 不能作用与最外层
    textColor,
    activeBackgroundColor, // 这部分应该作用于按钮
    activeBorderColor,
    activeTextColor,
    onClick,
  } = props
  if (!(options && options.length)) {
    return null
  }
  return (
    <StyledContainer
      style={style}
      className={className}
      size={size}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      textColor={textColor}
    >
      {(options || []).map((item, key) => {
        let styleButton = {
          borderRadius: '0px',
          backgroundColor:
            item.key === activeKey ? activeBackgroundColor : backgroundColor,
          color: item.key === activeKey ? activeTextColor : textColor,
          borderColor: item.key === activeKey ? activeBorderColor : borderColor,
          borderStyle: 'solid',
          borderWidth: item.key === activeKey ? '1px' : '1px 1px 1px 0',
        }
        if (key === 0) {
          styleButton = {
            ...styleButton,
            borderRadius: `${borderRadius}px 0 0 ${borderRadius}px`,
            borderWidth: '1px',
          }
        } else if (key === options.length - 1) {
          styleButton = {
            ...styleButton,
            borderRadius: `0 ${borderRadius}px ${borderRadius}px 0`,
          }
        }

        return (
          <Button
            type={activeKey === item.key ? activeType : type}
            style={styleButton}
            onClick={() => {
              if (onClick) {
                onClick(item.key)
              }
            }}
            size={size}
            {...item}
          >
            {item.label}
          </Button>
        )
      })}
    </StyledContainer>
  )
}

ButtonGroup.propTypes = {
  type: PropTypes.string,
  activeType: PropTypes.string,
  activeKey: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  borderRadius: PropTypes.number,
  onClick: PropTypes.func,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
  activeBorderColor: PropTypes.string,
  activeTextColor: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
}
ButtonGroup.defaultProps = {
  type: 'default',
  activeType: undefined,
  activeKey: undefined,
  size: 'md',
  className: undefined,
  borderRadius: undefined,
  onClick: undefined,
  backgroundColor: undefined,
  borderColor: undefined,
  textColor: undefined,
  activeBackgroundColor: undefined,
  activeBorderColor: undefined,
  activeTextColor: undefined,
  options: [],
}
export default ButtonGroup
